import { render, staticRenderFns } from "./AmountBreakdown.vue?vue&type=template&id=7bcbb32e&"
import script from "./AmountBreakdown.vue?vue&type=script&lang=js&"
export * from "./AmountBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports